'use client';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Home } from 'lucide-react';
import { BreadcrumbItem } from '@/types/common';

interface BreadcrumbMobileProps {
  items: BreadcrumbItem[];
  className?: string;
}

const BreadcrumbMobile: React.FC<BreadcrumbMobileProps> = ({ items, className = '' }) => {
  return (
    <div data-component-id="src/components/sections/mobile/BreadcrumbMobile.tsx:15:4" data-component-path="src/components/sections/mobile/BreadcrumbMobile.tsx" data-component-line="15" data-component-file="BreadcrumbMobile.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex flex-wrap items-center gap-2 p-4 ${className}`}>
      {/* Ícono de casa clicable */}
      <Link data-component-id="src/components/sections/mobile/BreadcrumbMobile.tsx:17:6" data-component-path="src/components/sections/mobile/BreadcrumbMobile.tsx" data-component-line="17" data-component-file="BreadcrumbMobile.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%2C%22className%22%3A%22flex%20items-center%22%7D" href="/" className="flex items-center">
        <Home data-component-id="src/components/sections/mobile/BreadcrumbMobile.tsx:18:8" data-component-path="src/components/sections/mobile/BreadcrumbMobile.tsx" data-component-line="18" data-component-file="BreadcrumbMobile.tsx" data-component-name="Home" data-component-content="%7B%22elementName%22%3A%22Home%22%2C%22className%22%3A%22w-4%20h-4%20text-%5B%233D1C1A%5D%20flex-shrink-0%20hover%3Aopacity-70%20transition-opacity%22%7D" className="w-4 h-4 text-[#3D1C1A] flex-shrink-0 hover:opacity-70 transition-opacity" />
      </Link>

      {items.map((item, index) => (
        <React.Fragment key={index}>
          {/* Flecha separadora */}
          <Image data-component-id="src/components/sections/mobile/BreadcrumbMobile.tsx:24:10" data-component-path="src/components/sections/mobile/BreadcrumbMobile.tsx" data-component-line="24" data-component-file="BreadcrumbMobile.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Fimg_vector_gray_900_v2.svg%22%2C%22alt%22%3A%22Arrow%22%2C%22className%22%3A%22flex-shrink-0%22%7D"
            src="/images/img_vector_gray_900_v2.svg"
            alt="Arrow"
            width={9}
            height={9}
            className="flex-shrink-0"
          />

          {/* Texto del item */}
          {item.href && !item.isCurrent ? (
            <Link data-component-id="src/components/sections/mobile/BreadcrumbMobile.tsx:34:12" data-component-path="src/components/sections/mobile/BreadcrumbMobile.tsx" data-component-line="34" data-component-file="BreadcrumbMobile.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22font-normal%20text-base%20leading-5%20hover%3Aopacity-70%20transition-opacity%22%7D"
              href={item.href}
              className="font-normal text-base leading-5 hover:opacity-70 transition-opacity"
              style={{
                fontFamily: "'TT_Norms_Pro-Regular', Helvetica",
                fontWeight: '400',
                color: 'rgba(61, 28, 26, 0.5)',
              }}
            >
              {item.label}
            </Link>
          ) : (
            <span data-component-id="src/components/sections/mobile/BreadcrumbMobile.tsx:46:12" data-component-path="src/components/sections/mobile/BreadcrumbMobile.tsx" data-component-line="46" data-component-file="BreadcrumbMobile.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-normal%20text-base%20leading-5%22%7D"
              className="font-normal text-base leading-5"
              style={{
                fontFamily: "'TT_Norms_Pro-Regular', Helvetica",
                fontWeight: item.isCurrent ? '700' : '400',
                color: item.isCurrent ? '#3D1C1A' : 'rgba(61, 28, 26, 0.5)',
              }}
            >
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default BreadcrumbMobile;
